module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"noExamsAvailable":"Keine Prüfungen vorhanden","exams":"Prüfungen"},"en":{"noExamsAvailable":"No exams available","exams":"Exams"}}')
  delete Component.options._Ctor
}
